module.exports = __webpack_public_path__ + "static/img/minicons1.c8b6778e.png";